// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1C523","footer":"styles_footer__3Cgm2","passCodeTooltip":"styles_passCodeTooltip__3ZohS"};